import {Typography} from '@sollapay/ui';
import {IconBox} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface ShareGuestsEmptyStateProps {
  readOnly: boolean;
}

/** No guests yet; the invite hint is only shown to people who can invite. */
export const ShareGuestsEmptyState: FC<ShareGuestsEmptyStateProps> = ({readOnly}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div
      data-slot="share-guests-empty"
      className="mt-1 flex items-start gap-3 rounded-lg border border-dashed border-border-purple bg-background-secondary p-3.5"
    >
      <IconBox icon="view" size="sm" shape="round" tone="purple" aria-hidden="true" />
      <span data-slot="text" className="flex min-w-0 flex-col gap-0.5">
        <Typography size="sm" weight="semibold">
          {t('share.guestsEmpty.title')}
        </Typography>
        {!readOnly && (
          <Typography size="xs" color="tertiary" className="whitespace-normal">
            {t('share.guestsEmpty.description')}
          </Typography>
        )}
      </span>
    </div>
  );
};
